<template>
  <div class="select-autocomplete">
    <div 
      class="select-row"
      v-for="(result, index) in searchResults" 
      :key="result.bonPartID"
      @click="selectStep(index)"
    >
      <span class="main-step">{{result.ref}}</span>
      <span class="equipment-step">-{{result.description}}</span>
    </div>
  </div>
</template>

<script>
  export default {
    components: {
    },
    props: {
      searchResults: Array
    },
    data() {
      return {
      }
    }, 
    mounted() {
    },
    methods: {
      selectStep(index) {
        this.$emit('selectedPart', this.searchResults[index])
      },
    },
  }
</script>

<style lang="scss" scoped>
@import "@/style/base";
@import "@/style/components/buttons";
@import "@/style/components/modals";
@import "@/style/components/autocompleteList";

</style>
